<template>
  <div>
    <div>
      <div class="row">
        <ol class="breadcrumb">
          <li>
            <a>
              <router-link to="/">
                <em class="fa fa-home"></em>
              </router-link>
            </a>
          </li>
          <li class="active">
            Cuenta de acceso a Tarjetas Ecotrónica
          </li>
        </ol>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <!-- <h2>Basic Panels</h2> -->
        </div>
        <div class="col-md-6">
          <div class="panel panel-primary md-elevation-24" id="main">
            <div class="panel-heading">
              CAMBIAR CONTRASEÑA DE ACCESO
              <!-- <span class="pull-right panel-toggle"><em class="fa fa-check"></em></span> -->
            </div>

            <div class="panel-body">
              <div class="col-md-12">
                <vue-upload-multiple-image
                  @upload-success="uploadImageSuccess"
                  @before-remove="beforeRemove"
                  @edit-image="editImage"
                  @data-change="dataChange"
                  @limit-exceeded="limitExceeded"
                  :data-images="images"
                  :maxImage="1"
                  dragText="Carga tu foto"
                  browseText="Presiona aquí..."
                  primaryText="Foto"
                  popupText="Esta sera la foto de tu hoja de vida"
                ></vue-upload-multiple-image>
              </div>
              <div class="col-md-6" id="nombre">
                <md-field>
                  <label>Nueva contraseña</label>
                  <md-input
                    v-model="password"
                    placeholder="Nueva contraseña"
                    type="password"
                  ></md-input>
                </md-field>
              </div>
              <div class="col-md-6" id="nombre">
                <md-field>
                  <label>Repita contraseña</label>
                  <md-input
                    v-model="retryPassword"
                    placeholder="Repita contraseña"
                    type="password"
                  ></md-input>
                </md-field>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6" style="padding-top: 30px;">
                    <button
                      @click="saveInformation()"
                      style="width:50%"
                      class="btn btn-primary"
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>

<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
import VueUploadMultipleImage from '../Helpers/VueUploadMultipleImage';
import firebase, { firestore } from 'firebase';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { mapState } from 'vuex';
export default {
  name: 'cuenta',
  components: {
    Loading,
    VueUploadMultipleImage,
  },
  computed: mapState(['usuario', 'rol', 'usuarioId', 'image']),
  data: () => ({
    loading: false,
    password: '',
    retryPassword: '',
    images: [],
    imagen: '',
  }),
  created() {},
  mounted() {
    this.image != null ? this.reasignarImage(this.image) : '';
  },
  methods: {
    reasignarImage(url) {
      this.images.push({
        path: url,
        default: 1,
        highlight: 1,
        caption: 'caption to display. receive', // Optional
      });
    },
    showMessage(title, text, type) {
      Swal.fire({
        type: type,
        title: title,
        text: text,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    onCancel() {},
    saveInformation() {
      if (!this.password) {
        this.$noty.error('La contraseña es requerida');
      } else if (this.password != this.retryPassword) {
        this.$noty.error('Las contraseñas no coinciden');
        this.password = '';
        this.retryPassword = '';
      } else {
        this.loading = true;
        let data = {
          userId: this.usuarioId,
          newPassword: this.password,
          url: this.image || this.imagen,
        };
        ServiceApi.post(`/user/cambiarpassword`, data)
          .then(response => {
            this.loading = false;
            this.showMessage(
              '¡Excelente!',
              'Se realizó el cambio de contraseña con éxito',
              'success'
            );
            this.$router.push('/ordenes');
          })
          .catch(err => {});
      }
    },
    saveImage(image) {
      ServiceApi.post(`/save/image`, { image })
        .then(response => {
          this.loading = false;
          this.$noty.success('Foto de perfil actualizada con éxito');
        })
        .catch(err => {});
    },
    uploadImageSuccess(formData, index, fileList) {
      let date = new Date().getTime();
      this.loading = true;
      var uploadTask = firebase
        .storage()
        .ref('Users')
        .child(`${this.usuario}_${date.toLocaleString()}`)
        .put(fileList[0].file, {
          name: fileList[0].file.name,
          contentType: fileList[0].file.type,
        })
        .then(snapshot => {
          snapshot.ref.getDownloadURL().then(url => {
            this.imagen = url;
            this.saveImage(url);
            this.$store.commit('SET_URL_IMAGE', url);
            this.loading = false;
          });
        });
    },
    beforeRemove(index, done, fileList) {
      firebase
        .storage()
        .ref('Personas')
        .child(`${this.namePicture}`)
        .delete();
      var r = confirm('remove image');
      if (r == true) {
        done();
      } else {
      }
    },
    editImage(formData, index, fileList) {
      //console.log('edit data', formData, index, fileList)
      // firebase.storage().ref('Personas').child(`${this.namePicture}`).delete()
    },
    dataChange(data) {},
    limitExceeded(amount) {
      //console.log(amount)
    },
  },
};
</script>
